export const socialMediaOptions = [
  {
    name: 'Youtube',
    value: 'youtube',
  },
  {
    name: 'Facebook',
    value: 'facebook',
  },
  {
    name: 'Instagram',
    value: 'instagram',
  },
  {
    name: 'Tiktok',
    value: 'tiktok',
  },
  {
    name: 'Linkedin',
    value: 'linkedin',
  },
  {
    name: 'Twitter',
    value: 'twitter',
  },
];

export const successStatus = {
  type: 'SUCCESS',
  message: 'Successful response',
};
export const errorStatus = { type: 'ERROR', message: 'Something went wrong!' };
export const loadingStatus = { type: 'LOADING', message: 'Loading data!' };
export const idleStatus = { type: 'IDLE', message: 'Idle mode.' };

export const staticData = {
  title: 'Social Media',
  buttonLabel: 'Add',
};

export const editFormStaticPropsData = {
  typeInput: {
    label: 'Type',
    name: 'type',
    rules: [{ required: true, message: 'Please input type!' }],
    placeholder: 'Select a link type',
  },
  linkInput: {
    label: 'Link',
    name: 'link',
    rules: [{ required: true, message: 'Please input link!' }],
  },
  modal: {
    addTitle: 'Add Social info',
    editTitle: 'Edit Social info',
  },
};
